import {
  visitsDomain,
  partnersDomain,
  payerDomain as aggregatorsDomain,
} from '../../Common/constants';

export const businessUrl = `${visitsDomain}/visit-totals/per-payer/`;

export const partnersUrl = `${partnersDomain}/partner/`;

export const aggregatorsUrl = `${aggregatorsDomain}/aggregators/`;
